import { Component, OnInit, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { NewGuestModalComponent } from "@foh/publicpages/newreservationform/new-guest-modal/new-guest-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-guest-row',
  templateUrl: './guest-row.component.html',
  styleUrls: ['./guest-row.component.scss']
})
export class GuestRowComponent implements OnInit, OnDestroy {
  show: boolean = false;
  @Input() record: any;
  @Input() resTypeId: any;
  @Input() isTicketType: any;
  @Input() ticketPrices: any;
  @Input("count-label") countLabel: any;
  @Input() index: any;
  @Input("can-edit") canEdit: any;
  @Input("can-delete") canDelete: any;
  @Input() fbGuestMandatory: boolean;
  @Input() emailGuestMandatory: boolean;
  @Input() acceptInternationalNumbers: boolean;
  @Input() modeIsEdit: boolean;
  @Input() guestCounter: number = 1;
  @Input() isHost: boolean = false;
  @Output("on-delete") deleteEvent = new EventEmitter<any>();
  @Output("on-update") updateEvent = new EventEmitter<any>();
  @Input() openNewGuestModal: () => void;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.deleteEvent.unsubscribe();
    this.deleteEvent = null;
    this.updateEvent.unsubscribe();
    this.updateEvent = null;
  }

  toggleShow() {
    this.show = !this.show;
  }

  delete() {
    this.deleteEvent.emit(this.index);
  }

  editCurrentGuest() {
    const modalRef = this.modalService.open(NewGuestModalComponent, {
      windowClass: "foh-modal"
    });
    modalRef.componentInstance.resTypeId = this.resTypeId;
    modalRef.componentInstance.isTicketType = this.isTicketType;
    modalRef.componentInstance.ticketPrices = this.ticketPrices;
    modalRef.componentInstance.fbGuestMandatory = this.fbGuestMandatory;
    modalRef.componentInstance.emailGuestMandatory = this.emailGuestMandatory;
    modalRef.componentInstance.acceptInternationalNumbers = this.acceptInternationalNumbers;
    modalRef.componentInstance.prepareForEdit(this.record);
    modalRef.componentInstance.save.subscribe(params => {
      this.record = this.formatTicketCategoryForGuest(params);
      modalRef.componentInstance.activeModal.dismiss("Saved");
      this.updateEvent.emit(this.record);
    });
  }

  formatTicketCategoryForGuest(guest) {
    guest.formattedTicketCategory = "-";
    guest.formattedTicketDeadline = null;
    if (!this.isTicketType) {
      return guest;
    }
    var ticketCategory = this.getTicketCategoryById(guest.ticketcat_id);
    if (ticketCategory != false) {
      guest.formattedTicketCategory = this.formatTicketCategory(ticketCategory);
      if (ticketCategory.formattedValue.customdeadline) {
        guest.formattedTicketDeadline = ticketCategory.formattedValue.deadline;
      }
    }
    return guest;
  }

  getTicketCategoryById(ticketId) {
    for (var i = 0; i < this.ticketPrices.length; i++) {
      if (this.ticketPrices[i].id == ticketId) {
        return this.ticketPrices[i];
      }
    }
    return false;
  }

  formatTicketCategory(ticketCategory) {
    return ticketCategory.name + " - " + ticketCategory.price + " EGP";
  }
}
